import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';

const BASE = () => GetBackendUrlForGlobalFunctions() + 'system-settings/trade-contacts';

export interface TradeContactRow {
  id: number;
  trade_contact: number;
}

export const getTradeContacts = () =>
  axios.get<TradeContactRow[]>(BASE());

export const addTradeContact = (data: TradeContactRow) =>
  axios.post(BASE(), data);

export const updateTradeContact = (data: TradeContactRow) =>
  axios.put(BASE(), data);

export const deleteTradeContact = (data: TradeContactRow) => {
  const BASE = () => GetBackendUrlForGlobalFunctions() + 'system-settings';
  return axios.delete(BASE(), { data });
};

